import { queryClient } from '../query-client';
import { UnauthenticatedUserService } from './unauthenticated-user-service';
export const unauthenticatedUserService = new UnauthenticatedUserService({
    resource: 'user',
    parentResources: [],
    middleware: [],
    queryClient,
});
